export default __webpack_public_path__ + "static/media/social-img-1.929eca90.jpg";